import type { StripeM2SessionInvalidationOptions } from './stripe-m2-reader-session';

type StripeM2SessionInvalidator = (
  reason: string,
  options?: StripeM2SessionInvalidationOptions
) => Promise<void>;

let registeredInvalidator: StripeM2SessionInvalidator | null = null;

/** Register the POS reader coordinator without making logout import payment transport code. */
export function registerStripeM2SessionInvalidator(invalidator: StripeM2SessionInvalidator): void {
  registeredInvalidator = invalidator;
}

export async function invalidateRegisteredStripeM2Session(
  reason: string,
  options?: StripeM2SessionInvalidationOptions
): Promise<void> {
  await registeredInvalidator?.(reason, options);
}
